export default {
    "03-01": {
        year: 1926,
        title: "TÜRK CEZA KANUNU",
        text: "1926'da Türk Ceza Kanunu kabul edildi. 1896'da Habeşistan Adwa Savaşı'nı kazandı.",
        questions: [
            {
                text: "1926 TCK'nın İtalya'dan alınmasının temel hukuki gerekçesi neydi?",
                options: ["Kadın hakları", "Dönemin en liberal yasası olması", "İtalya ittifakı", "İdamın olmaması"],
                correct: 1
            },
            {
                text: "Türk-Afgan Dostluk Antlaşması'nı Türkiye adına imzalayan kimdir?",
                options: ["Bekir Sami Bey", "Yusuf Kemal Tengirşenk", "Dr. Rıza Nur", "Ali Fuat Cebesoy"],
                correct: 1
            },
            {
                text: "Adwa Savaşı'nda İtalya'yı yenen Habeşistan lideri kimdir?",
                options: ["Haile Selassie", "II. Menelik", "Jomo Kenyatta", "Kwame Nkrumah"],
                correct: 1
            }
        ]
    },
    "03-02": {
        year: 1918,
        title: "RİZE'NİN KURTULUŞU",
        text: "1918'de Rize kurtuldu. 1855'te II. Aleksandr Rus Çarı oldu.",
        questions: [
            {
                text: "Rize'nin kurtuluşunu sağlayan antlaşma hangisidir?",
                options: ["Moskova Antlaşması", "Brest-Litovsk Antlaşması", "Bükreş Antlaşması", "Kars Antlaşması"],
                correct: 1
            },
            {
                text: "Rusya'da serfliği kaldıran Çar II. Aleksandr Osmanlı ile hangi savaşı yaşamıştır?",
                options: ["Kırım Savaşı", "93 Harbi", "Prut Savaşı", "I. Dünya Savaşı"],
                correct: 1
            },
            {
                text: "Ozon tabakasının korunmasına dair en önemli protokol hangisidir?",
                options: ["Kyoto Protokolü", "Paris İklim Anlaşması", "Montreal Protokolü", "Rio Sözleşmesi"],
                correct: 2
            }
        ]
    },
    "03-03": {
        year: 1924,
        title: "HALİFELİĞİN KALDIRILMASI",
        text: "1924'te Halifelik kaldırıldı, Tevhid-i Tedrisat kabul edildi.",
        questions: [
            {
                text: "Şer’iye ve Evkaf Vekâleti yerine kurulan kurum hangisidir?",
                options: ["Diyanet İşleri Başkanlığı", "Şeyhülislamlık", "Vakıflar Genel Md.", "İlahiyat Fakültesi"],
                correct: 0
            },
            {
                text: "Erkân-ı Harbiye yerine kurulan ve ilk başkanı Fevzi Çakmak olan kurum nedir?",
                options: ["Milli Savunma Bakanlığı", "Genelkurmay Başkanlığı", "Kuvvet Komutanlıkları", "Yüksek Askeri Şura"],
                correct: 1
            },
            {
                text: "Tevhid-i Tedrisat ile eğitim kurumları hangi bakanlığa bağlanmıştır?",
                options: ["Sıhhiye Vekâleti", "Maarif Vekâleti", "Dahiliye Vekâleti", "Hariciye Vekâleti"],
                correct: 1
            }
        ]
    },
    "03-04": {
        year: 1925,
        title: "TAKRİR-İ SÜKÛN",
        text: "1925'te Takrir-i Sükûn Kanunu kabul edildi. 1193'te Selahaddin Eyyubi vefat etti.",
        questions: [
            {
                text: "Takrir-i Sükûn Kanunu'nu uygulamak için kurulan yargı organı hangisidir?",
                options: ["Yüce Divan", "İstiklal Mahkemeleri", "Divan-ı Harb-i Örfi", "DGM"],
                correct: 1
            },
            {
                text: "Kudüs'ü Haçlılardan geri alan 'Kudüs Fatihi' kimdir?",
                options: ["Nureddin Zengi", "Selahaddin Eyyubi", "Baybars", "Kılıç Arslan"],
                correct: 1
            },
            {
                text: "Takrir-i Sükûn Kanunu hangi yıla kadar yürürlükte kalmıştır?",
                options: ["1927", "1929", "1930", "1938"],
                correct: 1
            }
        ]
    },
    "03-05": {
        year: 1946,
        title: "DEMİR PERDE",
        text: "1946'da Churchill 'Demir Perde' konuşmasını yaptı. 1953'te Stalin öldü.",
        questions: [
            {
                text: "Churchill 'Demir Perde' konuşmasını hangi şehirde yapmıştır?",
                options: ["Washington", "Fulton", "New York", "Yalta"],
                correct: 1
            },
            {
                text: "SSCB'yi 30 yıl 'Çelik Yumruk'la yöneten lider kimdir?",
                options: ["Lenin", "Kruşçev", "Stalin", "Brejnev"],
                correct: 2
            },
            {
                text: "Yeşilay'ın kurucuları arasında yer alan dönemin Şeyhülislam'ı kimdir?",
                options: ["Rıfat Börekçi", "Elmalılı Hamdi", "İbrahim Bedrettin Haydarizade", "Ahmet Hamdi Akseki"],
                correct: 2
            }
        ]
    },
    "03-06": {
        year: 1995,
        title: "GÜMRÜK BİRLİĞİ",
        text: "1995'te Türkiye-AB Gümrük Birliği imzalandı. 1920'de Ömer Seyfettin vefat etti.",
        questions: [
            {
                text: "Gümrük Birliği Antlaşması'nı imzalayan dönemin Dışişleri Bakanı kimdir?",
                options: ["Tansu Çiller", "Murat Karayalçın", "Mesut Yılmaz", "Hikmet Çetin"],
                correct: 1
            },
            {
                text: "Ömer Seyfettin'in Milli Edebiyat akımını başlatan dergisi hangisidir?",
                options: ["Servet-i Fünun", "Genç Kalemler", "Türk Yurdu", "Dergah"],
                correct: 1
            },
            {
                text: "Filipinler'de yerlilerle girdiği çatışmada öldürülen ünlü kaşif kimdir?",
                options: ["Kolomb", "Vasco da Gama", "Magellan", "Elcano"],
                correct: 2
            }
        ]
    },
    "03-07": {
        year: 1921,
        title: "ARTVİN VE ARDAHAN",
        text: "1921'de Artvin ve Ardahan Türkiye'ye katıldı. 1954'te Petrol Kanunu kabul edildi.",
        questions: [
            {
                text: "Artvin ve Ardahan'ın Türkiye'ye bırakıldığı Gürcistan ile yapılan antlaşma nedir?",
                options: ["Gümrü Antlaşması", "Moskova Antlaşması", "Tiflis (Batum) Antlaşması", "Ankara Antlaşması"],
                correct: 2
            },
            {
                text: "1954 Petrol Kanunu hangi parti döneminde çıkarılmıştır?",
                options: ["CHP", "Demokrat Parti", "Adalet Partisi", "MSP"],
                correct: 1
            },
            {
                text: "'Kendime Düşünceler' eseriyle tanınan 'Filozof İmparator' kimdir?",
                options: ["Sezar", "Neron", "Marcus Aurelius", "Augustus"],
                correct: 2
            }
        ]
    },
    "03-08": {
        year: 1910,
        title: "DÜNYA KADINLAR GÜNÜ",
        text: "1910'da 8 Mart Kadınlar Günü kabul edildi.",
        questions: [
            {
                text: "8 Mart'ın kökeni olan 1857 grevi hangi ülkede yaşanmıştır?",
                options: ["İngiltere", "Fransa", "ABD", "Almanya"],
                correct: 2
            },
            {
                text: "Türkiye'de ilk 'Emekçi Kadınlar Günü' kutlamasına öncülük edenler kimlerdir?",
                options: ["Halide Edip", "Rahime Hanım", "Sabiha Sertel", "Rahime Selimova - Cemile Nuşirvanova"],
                correct: 3
            },
            {
                text: "1917 Rus Şubat Devrimi hangi gün başlamıştır?",
                options: ["1 Mayıs", "8 Mart", "Kanlı Pazar", "Donanma Günü"],
                correct: 1
            }
        ]
    },
    "03-09": {
        year: 1957,
        title: "EISENHOWER DOKTRİNİ",
        text: "1957'de Eisenhower Doktrini imzalandı. 1230'da Yassıçemen Savaşı yapıldı.",
        questions: [
            {
                text: "Eisenhower Doktrini Ortadoğu'da hangi ülkenin etkisini kırmak için geliştirilmiştir?",
                options: ["Çin", "SSCB", "Almanya", "İran"],
                correct: 1
            },
            {
                text: "Yassıçemen Savaşı'nda Alaeddin Keykubat hangi devleti yenmiştir?",
                options: ["Moğollar", "Harzemşahlar", "Bizans", "Memlükler"],
                correct: 1
            },
            {
                text: "Yassıçemen Savaşı'nın en olumsuz sonucu nedir?",
                options: ["Haçlı Seferleri", "Moğol istilasına açık hale gelme (Tampon kalktı)", "Bizans'ın güçlenmesi", "Başkent değişimi"],
                correct: 1
            }
        ]
    },
    "03-10": {
        year: 1876,
        title: "İLK TELEFON VE BOĞAZLIYANLI KEMAL",
        text: "1876'da ilk telefon görüşmesi yapıldı. 1919'da Boğazlıyanlı Kemal Bey idama mahkum edildi.",
        questions: [
            {
                text: "Graham Bell'in telefonda söylediği ilk cümle neydi?",
                options: ["Sesimi duyuyor musun?", "Bay Watson, buraya gelin.", "Tarih yazıyoruz.", "Alo?"],
                correct: 1
            },
            {
                text: "Ermeni Tehciri'ni uygulayan Dahiliye Nazırı kimdir?",
                options: ["Enver Paşa", "Cemal Paşa", "Talat Paşa", "Sait Halim Paşa"],
                correct: 2
            },
            {
                text: "II. Dünya Savaşı'nda tek gecede 100.000 sivilin öldüğü bombardıman nereye yapılmıştır?",
                options: ["Dresden", "Berlin", "Tokyo", "Hamburg"],
                correct: 2
            }
        ]
    },
    "03-11": {
        year: 1941,
        title: "ÖDÜNÇ VERME YASASI",
        text: "1941'de Lend-Lease Yasası kabul edildi. 1947'de Türkiye IMF'ye üye oldu.",
        questions: [
            {
                text: "Türkiye'nin IMF ile imzaladığı ilk stand-by anlaşması hangi yıldır?",
                options: ["1950", "1958", "1961", "1980"],
                correct: 2
            },
            {
                text: "Lend-Lease yardımlarından en çok yararlanan ülke hangisidir?",
                options: ["Fransa", "İngiltere", "Türkiye", "İtalya"],
                correct: 1
            },
            {
                text: "11 Mart 1917'de İngilizler hangi Osmanlı şehrini işgal etmiştir?",
                options: ["Şam", "Kudüs", "Bağdat", "Medine"],
                correct: 2
            }
        ]
    },
    "03-12": {
        year: 1921,
        title: "İSTİKLAL MARŞI",
        text: "1921'de İstiklal Marşı kabul edildi. 1971'de 12 Mart Muhtırası verildi.",
        questions: [
            {
                text: "İstiklal Marşı'nın günümüzde kullanılan bestesini kim yapmıştır?",
                options: ["Adnan Saygun", "Osman Zeki Üngör", "Cemal Reşit Rey", "Ulvi Cemal Erkin"],
                correct: 1
            },
            {
                text: "İstiklal Marşı anayasal hüküm olarak ilk kez hangi anayasada yer almıştır?",
                options: ["1921", "1924", "1961", "1982"],
                correct: 3
            },
            {
                text: "12 Mart Muhtırası sonrası kurulan teknokratlar hükümetinin başbakanı kimdir?",
                options: ["Bülent Ecevit", "Nihat Erim", "Ferit Melen", "Naim Talu"],
                correct: 1
            }
        ]
    },
    "03-13": {
        year: 1840,
        title: "NAMIK KEMAL VE URANÜS",
        text: "1840'ta Namık Kemal doğdu. 1781'de Uranüs keşfedildi.",
        questions: [
            {
                text: "Namık Kemal'in sahnelenen ilk tiyatro eseri hangisidir?",
                options: ["İntibah", "Cezmi", "Vatan yahut Silistre", "Gülnihal"],
                correct: 2
            },
            {
                text: "Atatürk'ün 'Benim naçiz vücudum...' sözünü söylemesine neden olan olay nedir?",
                options: ["Menemen Olayı", "İzmir Suikastı", "Şeyh Said İsyanı", "Çerkez Ethem"],
                correct: 1
            },
            {
                text: "'Hendesehane' hangi padişah döneminde açılmıştır?",
                options: ["I. Mahmud", "III. Selim", "III. Ahmed", "I. Abdülhamid"],
                correct: 0
            }
        ]
    },
    "03-14": {
        year: 1827,
        title: "TIP BAYRAMI",
        text: "1827'de Tıphane-i Amire açıldı. 1883'te Karl Marx öldü.",
        questions: [
            {
                text: "Tıp Bayramı'nı işgal altındaki İstanbul'da ilk kez kutlayan kurum hangisidir?",
                options: ["İstanbul Üniversitesi", "Darülfünun", "GATA", "Mekteb-i Tıbbiye-i Şahane"],
                correct: 3
            },
            {
                text: "Karl Marx'ın kapitalizmi eleştirdiği başyapıtı hangisidir?",
                options: ["Komünist Manifesto", "Das Kapital", "Ütopya", "Devlet ve Devrim"],
                correct: 1
            },
            {
                text: "II. Mahmud döneminde Yeniçeri Ocağı'nın kaldırılması olayına ne ad verilir?",
                options: ["Vaka-i Vakvakiye", "Edirne Vakası", "Vaka-i Hayriye", "Kuleli Vakası"],
                correct: 2
            }
        ]
    },
    "03-15": {
        year: 1921,
        title: "TALAT PAŞA SUİKASTI",
        text: "1921'de Talat Paşa şehit edildi. MÖ 44'te Jül Sezar öldürüldü.",
        questions: [
            {
                text: "Jül Sezar'ın 'Sen de mi...?' dediği manevi oğlu kimdir?",
                options: ["Antonius", "Brutus", "Cassius", "Augustus"],
                correct: 1
            },
            {
                text: "Talat Paşa'yı Berlin'de şehit eden Ermeni suikastçı kimdir?",
                options: ["Tehlirian", "Yanikyan", "Sasunyan", "Agopyan"],
                correct: 0
            },
            {
                text: "1892'de II. Abdülhamid tarafından kurulan sosyal yardım kurumu hangisidir?",
                options: ["Darüşşafaka", "Darülaceze", "Himaye-i Etfal", "Hilal-i Ahmer"],
                correct: 1
            }
        ]
    },
    "03-16": {
        year: 1920,
        title: "İSTANBUL'UN İŞGALİ",
        text: "1920'de İstanbul resmen işgal edildi. 1921'de Moskova Antlaşması imzalandı.",
        questions: [
            {
                text: "İstanbul'un işgalini Ankara'ya bildiren kahraman telgrafçı kimdir?",
                options: ["Köprülü Hamdi", "Manastırlı Hamdi", "Yüzbaşı Yahya", "Topkapılı Cambaz Mehmet"],
                correct: 1
            },
            {
                text: "Moskova Antlaşması ile Misak-ı Milli'den verilen ilk taviz neresidir?",
                options: ["Kars", "Ardahan", "Batum", "Iğdır"],
                correct: 2
            },
            {
                text: "Moskova Antlaşması ile Rusya hangisini reddetmiştir?",
                options: ["Sevr Antlaşması", "Kapitülasyonlar", "Boğazlar", "Osmanlı borçları"],
                correct: 0
            }
        ]
    },
    "03-17": {
        year: 1861,
        title: "İTALYA BİRLİĞİ",
        text: "1861'de İtalya Krallığı ilan edildi. 1948'de Brüksel Antlaşması imzalandı.",
        questions: [
            {
                text: "İtalya siyasi birliğinin mimarı olan Piyemonte Başbakanı kimdir?",
                options: ["Garibaldi", "Cavour", "Mazzini", "Mussolini"],
                correct: 1
            },
            {
                text: "1948'de AB ve NATO'nun savunma temellerinin atıldığı antlaşma hangisidir?",
                options: ["Roma", "Paris", "Brüksel", "Maastricht"],
                correct: 2
            },
            {
                text: "Atatürk'ün 'Sen omuzlar üzerinde göklere yükselmeye layıksın' dediği kadın kahraman kimdir?",
                options: ["Nene Hatun", "Adile Onbaşı", "Şerife Bacı", "Halide Edip"],
                correct: 1
            }
        ]
    },
    "03-18": {
        year: 1915,
        title: "ÇANAKKALE ZAFERİ",
        text: "1915'te 18 Mart Çanakkale Deniz Zaferi kazanıldı.",
        questions: [
            {
                text: "'Gittiler, geçemediler, geçemeyecekler' diyen 18 Mart Kahramanı kimdir?",
                options: ["Esat Paşa", "Cevat (Çobanlı) Paşa", "Kazım Karabekir", "Fevzi Çakmak"],
                correct: 1
            },
            {
                text: "Nusret'in mayınlarını döşeyen Mayın Grup Komutanı kimdir?",
                options: ["Yüzbaşı Faik", "Binbaşı Nazmi Bey", "Seyit Onbaşı", "Yahya Çavuş"],
                correct: 1
            },
            {
                text: "Nusret'in mayınlarına çarparak batan Fransız zırhlısı hangisidir?",
                options: ["Ocean", "Queen Elizabeth", "Bouvet", "Agamemnon"],
                correct: 2
            }
        ]
    },
    "03-19": {
        year: 1945,
        title: "SOVYET NOTASI",
        text: "1945'te SSCB Dostluk Antlaşması'nı feshetti. 2003'te Irak işgali başladı.",
        questions: [
            {
                text: "Türkiye'den toprak ve üs talep eden Sovyet Dışişleri Bakanı kimdir?",
                options: ["Molotov", "Gromyko", "Çiçerin", "Lavrov"],
                correct: 0
            },
            {
                text: "Mustafa Kemal Paşa'nın Ankara'da toplanacağını duyurduğu meclis hangi adla açılmıştır?",
                options: ["Meclis-i Mebusan", "Kurucu Meclis", "TBMM", "Danışma Meclisi"],
                correct: 2
            },
            {
                text: "ilk Osmanlı Parlamentosu'nun (Meclis-i Mebusan) başkanı kimdir?",
                options: ["Mithat Paşa", "Ahmet Vefik Paşa", "Namık Kemal", "Hasan Fehmi Paşa"],
                correct: 1
            }
        ]
    },
    "03-20": {
        year: 1799,
        title: "AKKA SAVUNMASI",
        text: "1799'da Napolyon Akka'da yenildi. 1602'de Hollanda Doğu Hindistan Şirketi kuruldu.",
        questions: [
            {
                text: "Napolyon'u Akka'da yenen 'Cezzar' lakaplı Osmanlı komutanı kimdir?",
                options: ["Kavalalı Mehmet Ali", "Cezzar Ahmed Paşa", "Alemdar Mustafa", "Köprülü Fazıl"],
                correct: 1
            },
            {
                text: "Hollanda Doğu Hindistan Şirketi hangi ekonomik sistemin sembolüdür?",
                options: ["Feodalizm", "Merkantilizm", "Sosyalizm", "Fizyokrasi"],
                correct: 1
            },
            {
                text: "Tunus'un bağımsızlık lideri ve ilk devlet başkanı kimdir?",
                options: ["Habib Burgiba", "Bin Ali", "Gannuşi", "Habib"],
                correct: 0
            }
        ]
    },
    "03-21": {
        year: 1973,
        title: "NEVRUZ VE AŞIK VEYSEL",
        text: "Nevruz Bayramı. 1973'te Aşık Veysel vefat etti.",
        questions: [
            {
                text: "Türklerin demirden dağı eriterek çıktığı Nevruz destanı hangisidir?",
                options: ["Türeyiş", "Göç", "Ergenekon", "Oğuz Kağan"],
                correct: 2
            },
            {
                text: "Şah Rıza Pehlevi ülkesinin adını 'Persia' yerine ne olarak değiştirmiştir?",
                options: ["Mezopotamya", "İran", "Horasan", "Elam"],
                correct: 1
            },
            {
                text: "Aşık Veysel'in Ahmet Kutsi Tecer tarafından keşfedildiği ilimiz hangisidir?",
                options: ["Sivas", "Kırşehir", "Erzurum", "Erzincan"],
                correct: 0
            }
        ]
    },
    "03-22": {
        year: 1945,
        title: "ARAP BİRLİĞİ",
        text: "1945'te Arap Birliği kuruldu. 1919'da Mussolini Faşist hareketini başlattı.",
        questions: [
            {
                text: "Arap Birliği merkezi Mısır-İsrail barışı sonrası geçici olarak nereye taşınmıştır?",
                options: ["Şam", "Bağdat", "Tunus", "Riyad"],
                correct: 2
            },
            {
                text: "Mussolini'nin iktidarı ele geçirmek için yaptığı yürüyüşün adı nedir?",
                options: ["Roma Yürüyüşü", "Uzun Yürüyüş", "Birahane Darbesi", "Kristal Gece"],
                correct: 0
            },
            {
                text: "Mavi Marmara olayı hangi yıl gerçekleşmiştir?",
                options: ["2009", "2010", "2011", "2012"],
                correct: 1
            }
        ]
    },
    "03-23": {
        year: 1921,
        title: "II. İNÖNÜ SAVAŞI",
        text: "1921'de II. İnönü Savaşı başladı. 1931'de Kubilay Anıtı açıldı.",
        questions: [
            {
                text: "İsmet Paşa II. İnönü Savaşı'nı hangi tepeden yönetmiştir?",
                options: ["Duatepe", "Kocatepe", "Metristepe", "Tınaztepe"],
                correct: 2
            },
            {
                text: "II. İnönü Savaşı sonrası Anadolu'dan çekilme kararı alan (ancak erteleyen) devlet hangisidir?",
                options: ["İngiltere", "Fransa", "İtalya", "Yunanistan"],
                correct: 1
            },
            {
                text: "II. İnönü Savaşı sırasında Yunan ordusunun başındaki general kimdir?",
                options: ["Venizelos", "Papoulas", "Hacıanestis", "Metaksas"],
                correct: 1
            }
        ]
    },
    "03-24": {
        year: 1999,
        title: "NATO KOSOVA HAREKATI",
        text: "1999'da NATO Yugoslavya'yı bombaladı. 1882'de verem mikrobu keşfedildi.",
        questions: [
            {
                text: "Yugoslavya savaş suçlusu lideri kimdir?",
                options: ["Karadzic", "Mladic", "Milosevic", "İzzetbegoviç"],
                correct: 2
            },
            {
                text: "Time dergisi Atatürk için 'The Magnificent Turk' ifadesini hangi olayla bağlantılı kullanmıştır?",
                options: ["Lozan", "Cumhuriyet", "Halifelik", "Saltanat"],
                correct: 0
            },
            {
                text: "Veremle mücadele için İzmir'de kurulan ilk cemiyet hangisidir?",
                options: ["Kızılay", "Verem Savaş", "Yeşilay", "İzmir Veremle Mücadele Cemiyeti"],
                correct: 3
            }
        ]
    },
    "03-25": {
        year: 1957,
        title: "ROMA ANTLAŞMASI",
        text: "1957'de AET kuruldu. 2009'da Muhsin Yazıcıoğlu vefat etti.",
        questions: [
            {
                text: "AET'nin 'Kurucu Altıları' arasında hangisi yoktur?",
                options: ["İtalya", "Hollanda", "İngiltere", "Lüksemburg"],
                correct: 2
            },
            {
                text: "Büyük Birlik Partisi (BBP) hangi partiden ayrılarak kurulmuştur?",
                options: ["MÇP (MHP)", "Refah", "DYP", "ANAP"],
                correct: 0
            },
            {
                text: "Milli Mücadele'de Türkçülük fikrini savunan dernek hangisidir?",
                options: ["Türk Yurdu", "Türk Ocakları", "Milli Kongre", "Kilikyalılar"],
                correct: 1
            }
        ]
    },
    "03-26": {
        year: 1913,
        title: "EDİRNE'NİN DÜŞÜŞÜ",
        text: "1913'te Edirne Bulgarlara teslim oldu. 1971'de Bangladeş bağımsız oldu.",
        questions: [
            {
                text: "Edirne savunmasıyla bilinen efsanevi komutan kimdir?",
                options: ["Enver Paşa", "Şükrü Paşa", "Kazım Karabekir", "Fahrettin Paşa"],
                correct: 1
            },
            {
                text: "Bangladeş'in kurucu lideri (Bangabandhu) kimdir?",
                options: ["Ziyaül Hak", "Cinnah", "Şeyh Muciburrahman", "Butto"],
                correct: 2
            },
            {
                text: "İttihat ve Terakki'nin hükümeti ele geçirdiği olay hangisidir?",
                options: ["31 Mart", "Kuleli", "Bâb-ı Âli Baskını", "Çırağan"],
                correct: 2
            }
        ]
    },
    "03-27": {
        year: 1923,
        title: "ALİ ŞÜKRÜ BEY OLAYI",
        text: "1923'te Ali Şükrü Bey öldürüldü. 1854'te Kırım Savaşı'na İngiltere-Fransa katıldı.",
        questions: [
            {
                text: "Ali Şükrü Bey cinayeti TBMM'de hangi grubun tasfiyesine yol açmıştır?",
                options: ["Tesanüd", "Islahat", "İkinci Grup (Muhalefet)", "Halk Zümresi"],
                correct: 2
            },
            {
                text: "Osmanlı ilk dış borcu Kırım Savaşı sırasında hangi ülkeden almıştır?",
                options: ["Fransa", "İngiltere", "Almanya", "Hollanda"],
                correct: 1
            },
            {
                text: "Tarihin en büyük uçak kazası hangi adada olmuştur?",
                options: ["Sicilya", "Tenerife", "Malta", "Girit"],
                correct: 1
            }
        ]
    },
    "03-28": {
        year: 1930,
        title: "ŞEHİR ADLARININ TÜRKÇELEŞTİRİLMESİ",
        text: "1930'da yabancı mektuplarda Türkçe şehir adları zorunlu oldu. 1969'da Alaşehir depremi oldu.",
        questions: [
            {
                text: "Şehir isimlerinin Türkçeleştirilmesi hangi kanunla ilgilidir?",
                options: ["Soyadı Kanunu", "Harf İnkılabı", "Posta Kanunu (Hizmetleri)", "Tevhid-i Tedrisat"],
                correct: 2
            },
            {
                text: "İspanya İç Savaşı'nı kazanan diktatör general kimdir?",
                options: ["Salazar", "Franco", "Mussolini", "Pinochet"],
                correct: 1
            },
            {
                text: "Vatikan'ı ziyaret eden ilk Türk Cumhurbaşkanı kimdir?",
                options: ["Celal Bayar", "Cemal Gürsel", "Cevdet Sunay", "Fahri Korutürk"],
                correct: 2
            }
        ]
    },
    "03-29": {
        year: 1432,
        title: "FATİH'İN DOĞUMU VE NATO",
        text: "1432'de Fatih Sultan Mehmed doğdu. 2004'te 7 ülke NATO'ya katıldı.",
        questions: [
            {
                text: "Fatih'in Manisa sancakbeyliği sırasında hocalığını yapan ünlü alim kimdir?",
                options: ["Molla Fenari", "Molla Gürani", "Ali Kuşçu", "Zenbilli Ali"],
                correct: 1
            },
            {
                text: "2004'te NATO'ya katılan Baltık ülkeleri hangileridir?",
                options: ["Polonya-Macaristan", "Estonya-Letonya-Litvanya", "Romanya-Bulgaristan", "Hırvatistan"],
                correct: 1
            },
            {
                text: "Fatih'in Ortodoks Kilisesi'nin başına atadığı Patrik kimdir?",
                options: ["Gennadios", "Konstantin", "Jüstinyen", "Notaras"],
                correct: 0
            }
        ]
    },
    "03-30": {
        year: 1856,
        title: "PARİS ANTLAŞMASI",
        text: "1856'da Paris Antlaşması imzalandı. 1972'de Kızıldere Olayı yaşandı.",
        questions: [
            {
                text: "Paris Antlaşması'nın Osmanlı'ya 'mağlup devlet muamelesi' yaptıran maddesi nedir?",
                options: ["Toprak bütünlüğü", "Karadeniz'in silahsızlandırılması (Donanma yasağı)", "Islahat Fermanı", "Özerklikler"],
                correct: 1
            },
            {
                text: "Yavuz'dan sonra Mısır'ı ziyaret eden ilk Osmanlı padişahı kimdir?",
                options: ["Kavalalı", "İsmail Paşa (Hıdiv)", "Abdülaziz (Padişah)", "Tevfik Paşa"],
                correct: 2
            },
            {
                text: "Kızıldere Olayı'nda Mahir Çayan ve arkadaşları kimi kaçırmıştır?",
                options: ["ABD Büyükelçisi", "İngiliz teknisyenler", "İsrail Başkonsolosu", "NATO Komutanı"],
                correct: 1
            }
        ]
    },
    "03-31": {
        year: 1909,
        title: "31 MART VAKASI",
        text: "1909'da (Rumi 31 Mart) 31 Mart Vakası yaşandı. 1889'da Eyfel Kulesi açıldı.",
        questions: [
            {
                text: "31 Mart Vakası'nı bastıran ordunun adı nedir?",
                options: ["Hareket Ordusu", "Kuvâ-yi İnzibatiye", "Yıldırım Orduları", "Hamidiye Alayları"],
                correct: 0
            },
            {
                text: "Hareket Ordusu'nun Kurmay Başkanı kimdir?",
                options: ["Enver Paşa", "Mustafa Kemal", "Kazım Karabekir", "İsmet İnönü"],
                correct: 1
            },
            {
                text: "31 Mart Vakası sonucu tahta çıkan padişah kimdir?",
                options: ["V. Murad", "V. Mehmed Reşad", "Vahdettin", "Abdülmecid"],
                correct: 1
            }
        ]
    }
};
